import { Middleware, configureStore } from '@reduxjs/toolkit'
//import { createLogger } from 'redux-logger'
import rootReducer from './rootReducer'
import { schemaValidationMiddleware } from './middleware/schemaValidation'


const _CONF = {
  serializableCheck: false,
  immutableCheck: false
}

const middlewares: Middleware[] = []

// Add schema validation middleware
middlewares.push(schemaValidationMiddleware)

if (import.meta.env.MODE !== 'production') {
  //middlewares.push(createLogger() as Middleware)
}

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(_CONF).concat(middlewares as ReturnType<typeof getDefaultMiddleware>),
  devTools: import.meta.env.MODE !== 'production',
})

export type AppDispatch = typeof store.dispatch
